import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const EmptyTable = ({ icon, title, description, buttonText, onButtonClick, showButton = true }) => {
    return (
        <div className="bg-base-100 rounded-xl border border-base-300 p-12 shadow-md shadow-primary/5">
            <div className="text-center">
                <div className="w-16 h-16 bg-base-200 rounded-full flex items-center justify-center mx-auto mb-4">
                    <FontAwesomeIcon icon={icon} className="text-2xl text-base-content/40" />
                </div>
                <h3 className="text-lg font-semibold text-base-content mb-2">{title}</h3>
                <p className="text-base-content/70 mb-6">{description}</p>
                {showButton && buttonText && onButtonClick && (
                    <button className="btn btn-primary" onClick={onButtonClick}>
                        <FontAwesomeIcon icon={faPlus} className="mr-2" />
                        {buttonText}
                    </button>
                )}
            </div>
        </div>
    );
};

export default EmptyTable;
